import { useCallback } from 'react';
import qs from 'qs';
import axios from 'axios';

const useYoutubeAccount = () => {
  const AUTHORIZE_URL = 'https://accounts.google.com/o/oauth2/token';
  const CHANNEL_URL =
    'https://www.googleapis.com/youtube/v3/channels?part=id&mine=true&access_token=';

  const curLocation = window.location.href.split('?')[0];
  const queryStr = qs.stringify({
    client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID,
    redirect_uri: curLocation,
    response_type: 'code',
    scope: 'https://www.googleapis.com/auth/youtube.readonly',
    access_type: 'offline',
  });

  const loginUrl = 'https://accounts.google.com/o/oauth2/v2/auth?' + queryStr;
  const googleLogin = useCallback(() => {
    window.location.assign(loginUrl);
  }, []);

  const getChannelId = useCallback(async (auth_code, apply) => {
    try {
      const response = await axios.post(AUTHORIZE_URL, {
        code: auth_code,
        client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID,
        client_secret: process.env.REACT_APP_YOUTUBE_CLIENT_SECRET,
        redirect_uri: curLocation,
        grant_type: 'authorization_code',
      });

      const response2 = await axios.get(
        CHANNEL_URL + response['data']['access_token'],
        {
          headers: {
            Authorization: 'Bearer ' + response['data']['access_token'],
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
        }
      );
      if (!response2['data']['items']) {
        alert('유튜브 계정 연결에 실패하였습니다.');
        window.location.assign(curLocation);
        return;
      }

      apply(response2['data']['items'][0]['id']);

      window.history.pushState({}, null, curLocation);
    } catch (e) {
      alert(
        '유튜브 계정 연결에 실패하였습니다.' + e.response.data.error_description
      );
      window.location.assign(curLocation);
    }
  }, []);

  return { getChannelId, googleLogin };
};

export default useYoutubeAccount;
